import { gql } from '../utils/general';

export const getPublicationById = gql`
  query getPublicationById($id: uuid!) {
    resource: publications_by_pk(id: $id) {
      createdAt
      createdBy
      createdByUser {
        _id
        email
        entityId
        firstName
        lastName
        opengovId
        title
      }
      customCssCode
      description
      entityId
      id
      publicUrl
      publishedAt
      publishedBy
      status
      updatedAt
      updatedBy
      title
      thumbnailPath
      setTocAsLandingPage
      orgId
    }
  }
`;

export const getFoldersOfPublication = gql`
  query getFoldersOfPublication($where: storyFolders_bool_exp!) {
    storyFolders(where: $where) {
      id
      order
      title
      parentFolderId
    }
  }
`;

export const getFoldersOfPublicationWithStories = gql`
  query getFoldersOfPublication($publicationId: uuid!) {
    storyFolders(where: { publicationId: { _eq: $publicationId }, deletedAt: { _is_null: true } }) {
      id
      order
      title
      parentFolderId
      stories {
        _id
        title
        order
        state
        deletedAt
      }
    }
  }
`;

export const getStoriesListForPublicationFromRelevantFolders = gql`
  query getStoriesListForPublicationFromRelevantFolders(
    $where: stories_bool_exp!
    $limit: Int
    $offset: Int!
    $title: order_by
    $createdAt: order_by
    $updatedAt: order_by
    $order: order_by
  ) {
    count: stories_aggregate(
      where: $where
      order_by: [{ order: $order }, { title: $title }, { createdAt: $createdAt }, { updatedAt: $updatedAt }]
    ) {
      aggregate {
        count
      }
    }
    resources: stories(
      limit: $limit
      offset: $offset
      where: $where
      order_by: [{ order: $order }, { title: $title }, { createdAt: $createdAt }, { updatedAt: $updatedAt }]
    ) {
      _id
      createdAt
      createdBy
      entityId
      description
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      visibility
      author {
        firstName
        lastName
        email
        opengovId
        _id
      }
      publishedAt
      publishedBy
      storyKey
      folderId
      deletedAt
    }
  }
`;

export const getAllStoriesListForPublicationFromRelevantFolders = gql`
  query getAllStoriesListForPublicationFromRelevantFolders(
    $folderIds: [uuid!]
    $entityId: Int!
    $_like: String
    $_eq: String
    $_eq1: storyStates_enum
  ) {
    count: stories_aggregate(
      where: {
        deletedAt: { _is_null: true }
        folderId: { _in: $folderIds }
        entityId: { _eq: $entityId }
        title: { _like: $_like }
        authorId: { _eq: $_eq }
        state: { _eq: $_eq1 }
      }
    ) {
      aggregate {
        count
      }
    }
    resources: stories(
      where: {
        deletedAt: { _is_null: true }
        folderId: { _in: $folderIds }
        entityId: { _eq: $entityId }
        title: { _like: $_like }
        authorId: { _eq: $_eq }
        state: { _eq: $_eq1 }
      }
    ) {
      _id
      createdAt
      createdBy
      entityId
      description
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      visibility
      author {
        firstName
        lastName
        email
        opengovId
        _id
      }
      publishedAt
      publishedBy
      storyKey
      folderId
      deletedAt
    }
  }
`;

export const deleteStoriesAndFolderByFolderIds = gql`
  mutation deleteStoriesAndFolderByFolderIds($folderIds: [uuid!]) {
    delete_publicationNavigationMenuStories(where: { story: { folderId: { _in: $folderIds } } }) {
      affected_rows
    }
    update_stories(where: { folderId: { _in: $folderIds } }, _set: { deletedAt: "now()" }) {
      affected_rows
    }
    update_storyFolders(where: { id: { _in: $folderIds } }, _set: { deletedAt: "now()" }) {
      affected_rows
    }
  }
`;

export const deletePublicationById = gql`
  mutation deletePublication($id: uuid!, $entityId: Int) {
    delete_publications(where: { id: { _eq: $id }, entityId: { _eq: $entityId } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const updatePublicationById = gql`
  mutation updatePublication($publicationId: uuid!, $entityId: Int, $title: String, $description: String) {
    update_publications(
      where: { id: { _eq: $publicationId }, entityId: { _eq: $entityId } }
      _set: { title: $title, description: $description }
    ) {
      affected_rows
      returning {
        id
        title
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
        thumbnailPath
        status
        publishedAt
        publishedBy
        publicUrl
        entityId
        setTocAsLandingPage
        customCssCode
      }
    }
  }
`;

export const updatePublicationStatus = gql`
  mutation updatePublicationByStatus($publicationId: uuid!, $entityId: Int, $status: String) {
    update_publications(
      where: { id: { _eq: $publicationId }, entityId: { _eq: $entityId } }
      _set: { status: $status }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const renamePublicationSectionById = gql`
  mutation updateStoryFolder($entityId: Int, $title: String, $selectedSectionId: uuid!) {
    update_storyFolders(
      where: { entityId: { _eq: $entityId }, _and: { id: { _eq: $selectedSectionId } } }
      _set: { title: $title }
    ) {
      affected_rows
      returning {
        id
        entityId
        parentFolderId
        title
        order
      }
    }
  }
`;

export const storyFolderFieldsFragment = gql`
  fragment storyFolderFields on storyFolders {
    id
    title
    order
  }
`;

export const publicationFolderFieldsFragment = gql`
  fragment publicationFolderFields on storyFolders {
    id
    title
    order
    parentFolderId
    publication {
      title
      id
      orgId
    }
  }
`;

export const getAllPublicationsFolderHierarchy = gql`
  ${publicationFolderFieldsFragment}

  query getAllPublicationsFolderHierarchy($entityId: Int!, $orgId: uuid, $subjectIds: [uuid!]) {
    rootFolder: storyFolders(where: { entityId: { _eq: $entityId }, parentFolder: { parentFolderId: { _is_null: true } } }) {
      id
    }
    publicationFolders: storyFolders(
      where: {
        publicationId: { _is_null: false }, entityId: { _eq: $entityId }, deletedAt: { _is_null: true },
        _or: [
          { orgId: { _eq: $orgId } },
          { publication: { subjectPublicationClaims: { subjectId: { _in: $subjectIds }, publicationClaim: { _in: ["manage_all", "manage_shared_and_create_new"] } } } }
        ]
      }
    )
    { ...publicationFolderFields }
  }
`;

export const getAllPublicationsFolderHierarchyUnscoped = gql`
  ${publicationFolderFieldsFragment}

  query getAllPublicationsFolderHierarchyUnscoped($entityId: Int!) {
    rootFolder: storyFolders(where: { entityId: { _eq: $entityId }, parentFolder: { parentFolderId: { _is_null: true } } }) {
      id
    }
    publicationFolders: storyFolders(
      where: {
        publicationId: { _is_null: false }, entityId: { _eq: $entityId }, deletedAt: { _is_null: true }
      }
    )
    { ...publicationFolderFields }
  }
`;

export const deleteRootSectionInPublicationFolder = gql`
  mutation deleteRootSectionInPublicationFolders($publicationId: uuid!, $sectionId: uuid!) {
    delete_publicationFolders(where: { folderId: { _eq: $sectionId }, publicationId: { _eq: $publicationId } }) {
      returning {
        id
      }
    }
  }
`;

export const updatePublicationUpdatedAt = gql`
  mutation updateUpdatedAtOfPublication($publicationId: uuid!, $updatedAt: timestamptz, $userId: String!) {
    update_publications_by_pk(pk_columns: { id: $publicationId }, _set: { updatedAt: $updatedAt, updatedBy: $userId }) {
      id
    }
  }
`;

export const getFolderHierarchyWithStories = gql`
  fragment storyFolderFields on storyFolders {
    id
    title
    parentFolderId
    stories(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
      id: _id
      title
      state
      order
    }
  }

  query getFolderHierarchy($publicationId: uuid!, $entityId: Int!) {
    publicationRootFolder: storyFolders(where: { publicationId: { _eq: $publicationId }, entityId: { _eq: $entityId }, parentFolder: { parentFolderId: { _is_null: true } } }) {
      id
    }
    publicationFolders: storyFolders(
      where: {
        publicationId: { _eq: $publicationId }, entityId: { _eq: $entityId }, deletedAt: { _is_null: true }
      }
    )
    { ...storyFolderFields }
  }
`;

export const setTocAsLandingPage = gql`
  mutation updatePublication($publicationId: uuid!, $setTocAsLandingPage: Boolean) {
    update_publications_by_pk(pk_columns: { id: $publicationId }, _set: { setTocAsLandingPage: $setTocAsLandingPage }) {
      id
      title
      description
      createdAt
      createdBy
      customCssCode
      updatedAt
      updatedBy
      thumbnailPath
      status
      publishedAt
      publishedBy
      publicUrl
      entityId
      setTocAsLandingPage
    }
  }
`;

export const getRootFolderForEntity = gql`
  query getRootFolderForEntity($_entityId: Int) {
    storyFolders(where: { entityId: { _eq: $_entityId }, parentFolderId: { _is_null: true } }) {
      id
      title
    }
  }
`;

export const getPublicationRootFolder = gql`
  query getPublicationRootFolder($_publicationId: uuid!, $_entityId: Int!) {
    publicationFolders(
      where: {
        publicationId: { _eq: $_publicationId }
        storyFolder: { parentFolder: { parentFolderId: { _is_null: true } }, entityId: { _eq: $_entityId } }
      }
    ) {
      folderId
    }
  }
`;

export const getPublicationName = gql`
  query getPublicationName($publicationId: uuid!) {
    publications(where: { id: { _eq: $publicationId } }) {
      id
      title
    }
  }
`;

export const getFirstStoryForPublication = gql`
  query getFirstStoryForPublication($publicationId: uuid!, $entityId: Int!) {
    stories(
      where: { folder: { publicationId: { _eq: $publicationId }, entityId: { _eq: $entityId } } }
      order_by: { createdAt: asc }
      limit: 1
    ) {
      thumbnail
      thumbnailRelativePath
      _id
      title
    }
  }
`;

export const updatePublicationRootFolder = gql`
  mutation updatePublicationRootFolder($id: uuid!, $title: String!, $parentFolderId: uuid!) {
    update_storyFolders_by_pk(pk_columns: { id: $id }, _set: { parentFolderId: $parentFolderId, title: $title }) {
      id
    }
  }
`;

export const removePublicationIdFromFolders = gql`
  mutation removePublicationIdFromFolders($publicationId: uuid!) {
    update_storyFolders(where: { publicationId: { _eq: $publicationId } }, _set: { publicationId: null }) {
      affected_rows
    }
  }
`;

export const getPublicationFolderIds = gql`
  query getPublicationFolderIds($publicationId: uuid!, $entityId: Int!) {
    storyFolders(where: { publicationId: { _eq: $publicationId }, entityId: { _eq: $entityId } }) {
      id
    }
  }
`;

export const removePublicationRootFolder = gql`
  mutation removePublicationRootFolder($folderId: uuid!) {
    delete_storyFolders(where: { id: { _eq: $folderId } }) {
      affected_rows
    }
  }
`;

export const getNavigationMenusByPublicationId = gql`
  query getNavigationMenusByPublicationId($id: uuid!) {
    menuItems: publicationNavigationMenuItems(
      where: { publicationId: { _eq: $id } }
      order_by: [{ order: asc }, { title: asc }]
    ) {
      id
      publicationId
      title
      order
      createdAt
      createdBy
      updatedAt
      publicationNavigationMenuStories(order_by: { order: asc }) {
        id
        displayName
        menuId
        storyId
        order
        story {
          title
        }
      }
    }
  }
`;

export const getPublicationBrandings = gql`
  query getPublicationBrandings($id: uuid!) {
    publicationBrandings(where: { publicationId: { _eq: $id } }) {
      id
      idleBackgroundColor
      activeBackgroundColor
      activeFontColor
      createdAt
      enableLogoNavigation
      enableGoogleTranslate
      fontStyle
      idleFontColor
      isNavigationMenuSticky
      logoUrl
      publicationId
      showLogoOnFooter
      updatedAt
    }
  }
`;

export const getPublicationFooterSettings = gql`
  query getPublicationFooterSettings($entityId: Int!, $publicationId: uuid!) {
    publicationFooterSettings(
      where: { publication: { entityId: { _eq: $entityId } }, publicationId: { _eq: $publicationId } }
    ) {
      id
      publicationId
      backgroundColors
      fontColors
      mediaLinks
    }
  }
`;

export const getPublicationTocSettings = gql`
  query getPublicationTocSettings($id: uuid!) {
    publicationTOCSettings(where: { publicationId: { _eq: $id } }) {
      id
      columnLayoutNumber
      createdBy
      headerHeightSize
      headerImageUrl
      menuTitle
      pageTitle
      showTableOfContents
      createdAt
      publicationId
      updatedAt
      description
      hasUserToggledToc
    }
  }
`;

// modify to filter by type after populating story embeds data
export const getReportEmbedsForPublication = gql`
  query getReportEmbedsForPublication($publicationId: uuid!) {
    resources: storyEmbeds(where: { story: { folder: { publicationId: { _eq: $publicationId } } } }) {
      embedId
      storyId
      frequency
      reportId
      savedViewId
      type
    }
    count: storyEmbeds_aggregate(where: { story: { folder: { publicationId: { _eq: $publicationId } } } }) {
      aggregate {
        count
      }
    }
  }
`;

export const getPublicationStories = gql`
  query getPublicationStories($publicationId: uuid!, $entityId: Int!) {
    stories(
      where: {
        deletedAt: { _is_null: true }
        folder: { publicationId: { _eq: $publicationId } }
        entityId: { _eq: $entityId }
      }
    ) {
      _id
      title
      state
    }
  }
`;

export const getFolderStories = gql`
  query getFolderStories($folderIds: [uuid!], $entityId: Int!) {
    stories(
      where: { deletedAt: { _is_null: true }, folder: { id: { _in: $folderIds } }, entityId: { _eq: $entityId } }
    ) {
      _id
      title
      state
    }
  }
`;

export const getPublicationDataToCopy = gql`
  query getPublicationDataToCopy($id: uuid!) {
    publication: publications_by_pk(id: $id) {
      customCssCode
      setTocAsLandingPage
    }
  }
`;

export const getPublicationStoryEmbeds = gql`
  query getPublicationStoryEmbeds(
    $offset: Int
    $limit: Int
    $type: [String!]
    $authorId: String
    $folderIds: [uuid!]
    $publicationId: uuid!
    $order_by: [storyEmbeds_order_by!]
  ) {
    storyEmbeds(
      offset: $offset
      limit: $limit
      where: {
        authorId: { _eq: $authorId }
        type: { _in: $type }
        reportId: { _in: $folderIds }
        story: { deletedAt: { _is_null: true }, folder: { publicationId: { _eq: $publicationId } } }
        _or: [{ frequency: { _in: ["snapshot", "live", "refresh-on-update"] } }, { type: { _is_null: true } }]
      }
      order_by: $order_by
    ) {
      embedId
      authorId
      createdAt
      frequency
      reportId
      savedViewId
      type
      updatedAt
      story {
        title
        _id
      }
    }
    storyEmbeds_aggregate(
      where: {
        authorId: { _eq: $authorId }
        type: { _in: $type }
        reportId: { _in: $folderIds }
        story: { deletedAt: { _is_null: true }, folder: { publicationId: { _eq: $publicationId } } }
        _or: [{ frequency: { _in: ["snapshot", "live", "refresh-on-update"] } }, { type: { _is_null: true } }]
      }
      order_by: $order_by
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const deletePublicationNavigationMenuStories = gql`
  mutation deletePublicationNavigationMenuStories($storyIds: [String!]) {
    delete_publicationNavigationMenuStories(where: { storyId: { _in: $storyIds } }) {
      affected_rows
    }
  }
`;

export const getSubjectPublicationClaimByPublicationIdSubjectId = gql`
  query getSubjectPublicationClaimByPublicationIdSubjectId($publicationId: uuid!, $subjectIds: [uuid!]) {
    subjectPublicationClaims(where: { publicationId: { _eq: $publicationId }, subjectId: { _in: $subjectIds } }) {
      subjectId
      subjectType
      publicationId
      publicationClaim
      sectionIds
    }
  }
`;

export const getSubjectPublicationClaims = gql`
  query getSubjectPublicationClaims($where: subjectPublicationClaims_bool_exp!) {
    subjectPublicationClaims(where: $where) {
      subjectId
      subjectType
      publicationId
      publicationClaim
      sectionIds
    }
  }
`;

export const getSubjectStoryClaims = gql`
  query getSubjectStoryClaims($where: subjectStoryClaims_bool_exp!) {
    subjectStoryClaims(where: $where) {
      subjectId
      subjectType
      storyClaims
    }
  }
`;

export const groupsByMemberId = gql`
  query groupsByMemberId($memberId: UUID, $entityId: UUID) {
    groupsByMemberId(memberId: $memberId, entityId: $entityId) {
      groups {
        id
        name
      }
    }
  }
`;

export const getPublicationIdForStoryId = gql`
  query getPublicationIdForStoryId($storyId: String!) {
    story: stories_by_pk(_id: $storyId) {
      folder {
        publicationId
      }
    }
  }
`;

export const getExportPdfSettings = gql`
  query getExportPdfSettings($exportId: uuid!, $exportType: String!) {
    publicationSetupPdfStyles: exportPdfSettings(where: {exportType: {_eq: $exportType}, exportId: {_eq: $exportId }}) {
      coverStoryId
      createdBy
      footerControls
      headerControls
      pageMargins
      exportType
      storyStates
      tocData
      tocStyles
      watermark
      createdAt
      updatedAt
      exportId
      id
    }
  }
`;

export const deleteExportPdfSettings = gql`
  mutation deleteExportPdfSettings($exportId: uuid!) {
    delete_exportPdfSettings(where: { exportId: { _eq: $exportId } }) {
      affected_rows
      returning {
        exportId
        id
      }
    }
  }
`;
export const resetTocData = gql`
  mutation resetTocData($exportId: uuid!, $tocData: String) {
    update_exportPdfSettings(
      where: { exportId: { _eq: $exportId } }
      _set: { tocData: $tocData , coverStoryId: null}
    ) {
      affected_rows
    }
  }
`;